import { capitalized } from "@/libraries/helper";
import type React from "react";
import { useTranslation } from "react-i18next";

interface Props {
	children: React.ReactNode;
	subscriptionValue?: string;
	name: string;
	value: string;
	checked?: boolean;
	totalAmount?: any;
	plan?: any;
	onChange?: (value: string) => void;
}

const SelectPlan: React.FC<Props> = ({
	children,
	name,
	plan,
	value,
	checked,
	totalAmount,
	onChange,
}) => {
	const { t } = useTranslation("common");
	const handleClick = () => {
		if (onChange) {
			onChange(value);
		}
	};

	return (
		// biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
		<div
			className={`btn-select-plan ${checked ? "active" : ""} mx-auto`}
			onClick={handleClick}
		>
			<div className="flex justify-between items-center mx-3">
				<div className="text-pretty">{children}</div>
				<div className="flex flex-col items-center">
					<input
						type="radio"
						className="w-6 h-6"
						name={name}
						value={value}
						checked={checked}
						onChange={() => {}}
						aria-label="radio"
					/>
				</div>
			</div>
			{plan && (
				<div className="border-solid border-t-2 border-light-gray pt-2 mt-2 mb-2 mx-3">
					<div className="flex justify-between items-center mb-1">
						<span className="text-xs text-gray-100">
							{t("common:subscription")}
						</span>
						<span className="text-xs text-dark font-medium">
							{t("common:planBilling", {
								tier: capitalized(plan.tier),
								name: plan.name,
							})}
						</span>
					</div>
					<div className="flex justify-between items-center">
						<span className="text-xs text-gray-100">
							{t("common:totalAmount")}
						</span>
						<span className="text-xs text-dark font-medium">{totalAmount}</span>
					</div>
				</div>
			)}
		</div>
	);
};

export default SelectPlan;
